import { APP_UI_SETTING_CATALOG, PROFILE_SETUP_INTEREST_CATEGORIES_REQUIRED_SETTING_KEY, PROFILE_SETUP_PHONE_REQUIRED_SETTING_KEY, SALES_TOTAL_HOST_VISIBLE_SETTING_KEY, THEME_DARK_BACKGROUND_SETTING_KEY, THEME_DARK_SUB_BACKGROUND_SETTING_KEY, THEME_LIGHT_BACKGROUND_SETTING_KEY, THEME_LIGHT_SUB_BACKGROUND_SETTING_KEY, } from '../app-ui-settings/catalog.js';
import { fieldDefaultPayload, fieldPayloadOf, fieldValuesOf, mergeFieldPayload, validateFieldPayload, } from './fields.js';
import { SCREEN_FILE_EXTRA_FIELDS } from './screen-fields/catalog-screen-extras.js';
export const SCREEN_UI_CONFIG_SCREENS = [
    'common',
    'home',
    'market',
    'lounge',
    'chat',
    'me',
    'broadcast',
];
export const UI_CONFIG_SERVER_SETTING_KEYS = new Set([
    PROFILE_SETUP_PHONE_REQUIRED_SETTING_KEY,
    PROFILE_SETUP_INTEREST_CATEGORIES_REQUIRED_SETTING_KEY,
    SALES_TOTAL_HOST_VISIBLE_SETTING_KEY,
]);
export const UI_CONFIG_TOKEN_SETTING_KEYS = new Map([
    [THEME_LIGHT_BACKGROUND_SETTING_KEY, { mode: 'light', token: 'primary' }],
    [THEME_DARK_BACKGROUND_SETTING_KEY, { mode: 'dark', token: 'primary' }],
    [THEME_LIGHT_SUB_BACKGROUND_SETTING_KEY, { mode: 'light', token: 'secondary' }],
    [THEME_DARK_SUB_BACKGROUND_SETTING_KEY, { mode: 'dark', token: 'secondary' }],
]);
export function screenFileDefinitions(screen) {
    return [
        ...APP_UI_SETTING_CATALOG.filter((definition) => definition.screen === screen &&
            definition.deprecated !== true &&
            !UI_CONFIG_SERVER_SETTING_KEYS.has(definition.key) &&
            !UI_CONFIG_TOKEN_SETTING_KEYS.has(definition.key)),
        ...(SCREEN_FILE_EXTRA_FIELDS[screen] ?? []),
    ];
}
export function isScreenFileSettingKey(key) {
    return APP_UI_SETTING_CATALOG.some((definition) => definition.key === key &&
        SCREEN_UI_CONFIG_SCREENS.some((screen) => screenFileDefinitions(screen).some((field) => field.key === key)));
}
export function isUiConfigMovedSettingKey(key) {
    return UI_CONFIG_TOKEN_SETTING_KEYS.has(key) || isScreenFileSettingKey(key);
}
export function screenPayloadOf(screen, values) {
    return fieldPayloadOf(screen, values);
}
export function screenSettingsOf(screen, payload) {
    return fieldValuesOf(screen, payload);
}
export function screenDefaultPayload(screen) {
    return fieldDefaultPayload(screen, screenFileDefinitions(screen));
}
export function validateScreenPayload(screen, payload) {
    return validateFieldPayload(`screen.${screen}`, screen, screenFileDefinitions(screen), payload);
}
export function mergeScreenPayload(screen, builtIn, received) {
    return mergeFieldPayload(screen, screenFileDefinitions(screen), builtIn, received);
}
//# sourceMappingURL=screens.js.map